import Box from '@mui/material/Box';
import { Formik } from 'formik';
import * as yup from 'yup';
import { MFTextField, MFSubmitButton } from '../../lib/formik';
import { useDispatch } from 'react-redux';
import { loginWithOtp } from '../../redux-store/actions/auth';
import { useHistory, useRouteMatch } from 'react-router';
import { emailRegex, phoneRegExp } from '../../utils/regex';
import {
  GetDetailsFromRefIDResponse,
  GetOtpForInvestorResponse,
  LoginWithOtpResponseBody,
} from '../../redux-store/types/api-types';
import { CountryCodesDropDown, LoginLayout } from '../commonComponents';
import { getCountryCodes, preventSpecialCharacters } from '../../utils/utilityFunctions';
import { CountryCode, isValidPhoneNumber } from 'libphonenumber-js';
import { useEffect, useState } from 'react';
import {
  getDetailsWithReferenceId,
  getEmailWithReferenceId,
  getOtpForInvestor,
} from '../../redux-store/actions/onBoarding';

interface Values {
  email: string;
}

const validationSchema = yup.object().shape({
  email: yup
    .string()
    .nullable()
    .matches(emailRegex, 'Invalid Email ID')
    .required('Email ID is required'),
});

export default function EmailLogin(): JSX.Element {
  const dispatch = useDispatch();
  const history = useHistory();
  const { params } = useRouteMatch();
  const { referenceId } = params as unknown as { referenceId: string };
  const [isLoading, setIsLoading] = useState(false);
  const [isIntialLoading, setIsIntialLoading] = useState(false);
  const [details, setDetails] = useState({
    email: '',
  });
  useEffect(() => {
    let isComponentAlive = true;
    (async function () {
      try {
        setIsIntialLoading(true);
        const response = (await dispatch(getEmailWithReferenceId(referenceId))) as unknown as {
          email: string;
        };
        if (!isComponentAlive) return;
        setDetails(response);
      } catch (e) {
        console.error((e as Error).message);
      } finally {
        setIsIntialLoading(false);
      }
    })();
    return () => {
      isComponentAlive = false;
    };
  }, []);
  const verifyUser = async () => {
    try {
      setIsLoading(true);
      const response = (await dispatch(
        getOtpForInvestor(referenceId)
      )) as unknown as GetOtpForInvestorResponse;
      history.push(`/investment-details/${referenceId}/verify-otp`, {
        ...(response || {}),
        mobile: (response || {}).phone,
        email: (response || {}).email,
        loginType: 'investor',
        referenceId,
      });
    } catch (e) {
      console.error((e as Error).message);
    } finally {
      setIsLoading(false);
    }
  };
  const initialValues: Values = {
    email: details.email,
  };
  return (
    <LoginLayout LoginText="Login">
      <Formik
        onSubmit={verifyUser}
        enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}>
        {({ handleSubmit }) => (
          <Box
            component="form"
            noValidate
            onSubmit={handleSubmit}
            sx={{
              '.MuiLoadingButton-root': {
                mt: 5,
              },
              '.MuiInputLabel-root': {
                fontFamily: 'Poppins, sans-serif',
                fontSize: 16,
                fontWeight: 500,
              },
            }}>
            <MFTextField
              autoComplete="off"
              label="Email ID"
              name="email"
              placeholder="Enter Email ID"
              required
              disabled={!!referenceId}
              skeletonLoader={isIntialLoading}
            />
            <MFSubmitButton label="Get OTP" loadingEnable={isLoading} disabled={isIntialLoading} />
          </Box>
        )}
      </Formik>
    </LoginLayout>
  );
}
